import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { getConfig } from 'utils/config'
import { parse } from 'date-fns'

export const PARTNERPLAN_RATINGS_GET = 'PARTNERPLAN_RATINGS_GET'
export const PARTNERPLAN_RATINGS_RECEIVED = 'PARTNERPLAN_RATINGS_RECEIVED'
export const PARTNERPLAN_RATINGS_GET_ERROR = 'PARTNERPLAN_RATINGS_GET_ERROR'
export const PARTNERPLAN_RATINGS_DELETE_RECEIVED = 'PARTNERPLAN_RATINGS_DELETE_RECEIVED'
export const PARTNERPLAN_RATINGS_DELETE_COMPLETE = 'PARTNERPLAN_RATINGS_DELETE_COMPLETE'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const deleteDocumentRatingRequest = () => ({
  type: PARTNERPLAN_RATINGS_DELETE_RECEIVED,
})

const deleteDocumentRatingComplete = result => ({
  result,
  type: PARTNERPLAN_RATINGS_DELETE_COMPLETE,
})

const partnerPlanRatingsReceive = ratingsUploaded => ({
  type: PARTNERPLAN_RATINGS_RECEIVED,
  ratingsUploaded,
})

const mapPartnerPlanUploadRatings = (result) => {
  const docLib = getConfig().PLAN_RATINGS
  const docLibLogs = getConfig().PLAN_RATINGS_LOG
  const ratingsUploaded = result.map(ratings => ({
    itemId: ratings.ItemID,
    path: ratings.URL,
    logPath: (ratings.URL ? ratings.URL.replace(docLib, docLibLogs).replace('.csv', '.log') : ''),
    status: ratings.Status,
    documentName: ratings.Name,
    created: ratings.Created,
    modified: ratings.Modified,
    modifiedDate: parse(ratings.Modified, constants.DATE_FORMAT.SPO_FORMAT, new Date()),
  }))

  return ratingsUploaded.sort((a, b) => b.modifiedDate - a.modifiedDate)
}

export function sendNotification(message) {
  return (dispatch) => { 
    dispatch(notify(message))
  }
}

export function getPartnerPlanUploadRatings(libraryName, folderName) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLAN_RATINGS_GET))
    agent.PartnerPlans.getratings(libraryName, folderName).then((response) => {
      dispatch(partnerPlanRatingsReceive(mapPartnerPlanUploadRatings(response)))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getPartnerPlanRatings>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_RATINGS_GET_ERROR))
      }
    })
  }
}

export function deletePartnerPlanUploadRatings(itemId, libraryName, folderName) {
  return (dispatch) => {
    dispatch(deleteDocumentRatingRequest())
    agent.FileUploader.deleterating(itemId, libraryName, folderName).then((response) => {
      dispatch(partnerPlanRatingsReceive(mapPartnerPlanUploadRatings(response)))
      dispatch(notify('Partner plan rating CSV document deleted'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <deletePartnerPlanUploadRatings>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_RATINGS_GET_ERROR))
      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/actions/partnerPlanRatingsUpload.js